import React from "react";
import { Icon } from "@iconify/react";
import "./IconButton.scss"; // Import your SCSS file

const IconButton = ({
  variant,
  icon,
  onClick,
  disabled,
  className,
  type = "button",
  title,
  ...rest
}) => {
  // Combine the className prop with the variant-specific class
  const buttonClass = `icon-button icon-button--${variant} ${
    className || ""
  }`.trim();

  return (
    <button
      className={buttonClass}
      onClick={onClick}
      disabled={disabled}
      type={type}
      title={title}
      aria-label={title}
      {...rest}
    >
      <Icon icon={icon} />
    </button>
  );
};

export default IconButton;
